import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5473686e")

_pushScopeId("data-v-5473686e")
const _hoisted_1 = { class: "image-preview" }
const _hoisted_2 = { class: "content-preview" }
const _hoisted_3 = { class: "commands" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "戻る", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_modal, {
      isShow: _ctx.isShowPreviewInner,
      "onUpdate:isShow": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowPreviewInner = $event)),
      title: "プレビュー",
      isLeftTitle: true,
      isFitSize: true,
      onKeydown: _withKeys(_withModifiers(_ctx.enterAction, ["prevent"]), ["enter"])
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: {
            valign: _ctx.imagePreview.outputStyle.outputType == _ctx.vAlign,
            twobytwo: _ctx.imagePreview.outputStyle.outputType == _ctx.twoBytwo,
            split:
              _ctx.imagePreview.outputStyle.outputType == _ctx.split ||
              _ctx.imagePreview.outputStyle.outputType == _ctx.splitBySelect,
          }
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imagePreview.images, (image, i) => {
              return (_openBlock(), _createBlock("img", {
                key: i,
                src: image,
                class: {
              lt: i == 0,
              rt: i == 1,
              lb: i == 2,
              rb: i == 3,
            }
              }, null, 10, ["src"]))
            }), 128))
          ], 2),
          _createVNode("div", _hoisted_3, [
            _createVNode("button", {
              class: "primary-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowPreviewInner = false))
            }, [
              _hoisted_4
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShow", "onKeydown"])
  ]))
})